import Vue from 'vue';
import Router from 'vue-router';

import CourseListPage from 'vues/course-application/components/pages/CourseListPage';
import ApplicationFormPage from 'vues/course-application/components/pages/ApplicationFormPage';
import ConsentPage from 'vues/course-application/components/pages/ConsentPage';
import MedicalCheckPage from 'vues/course-application/components/pages/MedicalCheckPage';
import ConfirmPage from 'vues/course-application/components/pages/ConfirmPage';
import CompletedPage from 'vues/course-application/components/pages/CompletedPage';
import store from 'store/';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      component: CourseListPage,
      beforeEnter: async (to, from, next) => {
        if (from.path === '/') {
          // ショップを取得する
          store.commit('shop/reset');
          await store.dispatch('shop/getShopsForCourseApplication');

          // コースを取得する
          store.commit('course/reset');
          await store.dispatch('course/getCoursesForCourseApplication');

          // メディカルチェックの質問を取得する
          store.commit('medicalCheck/reset');
          await store.dispatch('medicalCheck/getQuestions');

          if (process.env.RAILS_ENV === 'development') {
            // テスト用データをセットする
            store.commit('courseApplication/resetForTest');
          } else {
            // 入力項目をクリアする
            store.commit('courseApplication/reset');
          }
        }
        next();
      },
    },
    {
      path: '/application-form',
      component: ApplicationFormPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/' || from.path === '/consent') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/consent',
      component: ConsentPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/application-form' || from.path === '/medical-check') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/medical-check',
      component: MedicalCheckPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/consent') {
          next();
        } else if (from.path === '/confirm') {
          let course = store.getters['courseApplication/course'];
          if (course === null) next('/');
          if (!course.name) next('/');
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/confirm',
      component: ConfirmPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/medical-check') {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/completed',
      component: CompletedPage,
      beforeEnter: (to, from, next) => {
        if (from.path === '/confirm') {
          next();
        } else {
          next('/');
        }
      },
    },
  ],
  /**
   * 参考：https://codekneading.com/blog/2019/11/vue-router-scroll-position.html#%E6%A6%82%E8%A6%81
   * @param {} to
   * @param {*} from
   * @param {*} savedPosition
   * @returns
   */
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // return new Promise((resolve, reject) => {
      //   setTimeOut(() => {
      //     resolve(savedPosition);
      //   });
      // });
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
